<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="grid_row" v-else>
      <v-card elevation="6">
        <div class="pa-2">
          <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
            <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
          </v-slide-x-reverse-transition>
          <div class="grid_half">
            <div class="grid_list pa-4">
              <div class="mr-1">
                <div>เลขที่/PO No.</div>
                <div class="pl-3 pt-1 grey--text">{{ header_list.po_code }}</div>
              </div>
              <div class="mr-1 mb-2">
                <div>เลขที่ใบเสร็จ</div>
                <div class="pl-3 pt-1 grey--text">{{ header_import.receipt_no }}</div>
              </div>
              <div class="mr-1">
                <div>ชื่อบริษัท/Supplier Name</div>
                <div class="pl-3 pt-1 grey--text">{{ header_list.supplier_name }}</div>
              </div>
              <div class="mr-1">
                <div>วันที่ใบเสร็จ (วัน/เดือน/ปี)</div>
                <div class="pl-3 pt-1 grey--text">{{ date }}</div>
              </div>
            </div>
            <div class="ma-4">
              <div class="ml-1">
                <div>ภาษีการซื้อ</div>
              </div>
              <div class="grey--text mr-1">
                <div class="pl-3 pt-1" v-if="header_list.type_vat === 0">
                  ภาษีรวมใน
                </div>
                <div class="pl-3 pt-1" v-if="header_list.type_vat === 1">
                  ภาษีแยกนอก
                </div>
                <div class="pl-3 pt-1" v-if="header_list.type_vat === 2">
                  ไม่กระทบภาษี
                </div>
                <div class="pl-3 pt-1" v-if="header_list.type_vat === 3">
                  ภาษีเป็น 0
                </div>
              </div>
            </div>
          </div>
          <div class="grid_half">
            <div v-if="header_list.po_type === 1">
              <div class="grid_list pa-4">
                <div class="mr-1">
                  <div>วันที่ครบกำหนด (วัน/เดือน/ปี)</div>
                  <div class="pl-3 pt-1 grey--text">{{ dateDue }}</div>
                </div>
              </div>
            </div>
            <div v-else></div>
            <div class="ma-4">
              <div class="ml-1">
                <div>ประเภท</div>
              </div>
              <div class="grey--text mr-1">
                <!-- <div class="pl-3 pt-1" v-if="header_list.po_type === 0">
                  เงินสด
                </div>
                <div class="pl-3 pt-1" v-else-if="header_list.po_type === 1">
                  เครดิต
                </div>
                <div v-else>-</div> -->
                <div class="pl-3 pt-1">
                  เครดิต
                </div>
              </div>
            </div>
          </div>
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table class="mb-2" :headers="Po_List" :items="data_list" key="index" item-key="product_code" :search="search" mobile-breakpoint="0" hide-default-footer>
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.index +1 }}</td>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>{{ dataDetail.item.unit_name }}</td>
                <td>{{ diffDate_Change(dataDetail.item.date_exp) }}</td>
                <td>{{ format_number(dataDetail.item.qty_received) }}</td>
                <td>{{ format_price(dataDetail.item.price) }}</td>
                <td>
                  <div v-if="dataDetail.item.discount_unit !== null">{{ dataDetail.item.discount_unit }}</div>
                  <div v-else>0.00</div>
                </td>
                <td>
                  <div v-if="dataDetail.item.discount !== null">{{ dataDetail.item.discount }}</div>
                  <div v-else>0</div>
                </td>
                <td>
                  <div class="text-center" v-if="dataDetail.item.status_return !== 0">รอคืน</div>
                  <div class="text-center" v-else>-</div>
                </td>
                <td>{{ format_price(dataDetail.item.total_price = (( (dataDetail.item.price) - ((dataDetail.item.price * dataDetail.item.discount) / 100)) * dataDetail.item.qty_received) - dataDetail.item.discount_unit) }}</td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="8" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">รวม</div>
                  </div>
                </td>
                <td colspan="5" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">{{ send_po_receipt.sub_total = total }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>ส่วนลดท้ายบิล (%)</div>
                  </div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4 text-center">{{ format_price(header_import.discount_percent) }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>ส่วนลดท้ายบิล (หน่วย)</div>
                  </div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4 text-center">{{ format_price(header_import.discount) }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="border_col">
                  <div class="ml-2 mb-7">ราคาสินค้าไม่รวมภาษี</div>
                  <div class="ml-2 pt-1">ภาษีมูลค่าเพิ่ม 7%</div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4 text-center">{{ send_po_receipt.product_no_vat = no_vat }}</div>
                  <v-divider/>
                  <div class="ma-4 text-center">{{ send_po_receipt.product_add_vat = cal_vat }}</div>
                </td>
              </tr>
              <tr>
                <td colspan="8" class="pa-2 border_col"></td>
                <td colspan="2" class="pa-2 border_col">
                  <div class="ma-4">
                    <div>จำนวนเงินทั้งสิ้นรวมภาษี</div>
                  </div>
                </td>
                <td colspan="3" class="pa-2 border_col">
                  <div class="ma-4">
                    <div class="text-center">{{ format_price(send_po_receipt.grand_total = (total_all - send_po_receipt.discount_final)) }}</div>
                  </div>
                </td>
              </tr>
              <v-divider/>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {diffChangeFormat, formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "PU_details",
  data() {
    return {
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      date: '',
      dateEN: '',
      dateDue: '',
      search: null,
      menu_date: false,
      send_po_receipt: {
        po_lists_id: null,
        receipt: null,
        type_vat: null,
        supplier_id: null,
        supplier_name: null,
        po_date: null,
        discount_bill: 0,
        product_no_vat: 0,
        product_add_vat: 0,
        discount_final: 0,
        grand_total: 0,
        sub_total: 0,
      },
      Po_List: [
        {
          text: 'ลำดับ',
          value: 'index',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '125px',
        },
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '170px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '180px',
        },
        {
          text: 'วันที่หมดอายุ',
          value: 'date_exp',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวนที่ได้รับ',
          value: 'qty_received',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สินค้ารอคืน',
          value: 'status_return',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          sortable: false,
          fixed: true,
          width: '100px',
        },
      ],
      product_list: [],
      po_lists: [],
      data_list: [],
      header_list: [],
      header_import: [],
    }
  },
  methods: {
    diffDate_Change: function(value) {
      return diffChangeFormat(value)
    },
    diffTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.date = final_date
    },
    diffDueTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.dateDue = final_date
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/creditor/pupo', {
        po_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.object.po
          this.header_import = res.data.object.imports
          if (res.data.object.po.po_date !== null) {
            this.date = res.data.object.po.po_date
            this.diffTH(this.date)
          }
          else {
            this.date = ''
          }
          if (res.data.object.imports.credit_date !== null) {
            this.dateDue = res.data.object.imports.credit_date
            this.diffDueTH(this.dateDue)
          }
          else {
            this.dateDue = ''
          }
          this.data_list = res.data.object.po_lists
          this.send_po_receipt.discount_bill = res.data.object.po.discount_bill
        }
      })
    },
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
        if (total_price < 0) {
          return sum+(0);
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    no_vat() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        if (this.header_list.type_vat == 0){
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          let in_vat = ((total_price * 7)/107);
          let total_grand = total_price - in_vat
          if (total_grand < 0) {
            return sum+(0);
          }
          else {
            return sum+(total_grand);
          }
        }
        else if(this.header_list.type_vat == 1) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          if (total_price < 0) {
            return sum+(0);
          }
          else {
            return sum+((total_price));
          }
        }
        else if(this.header_list.type_vat == 2) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          if (total_price < 0) {
            return sum+(0);
          }
          else {
            return sum+((total_price));
          }
        }
        else if(this.header_list.type_vat == 3) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          if (total_price < 0) {
            return sum+(0);
          }
          else {
            return sum+((total_price));
          }
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    cal_vat() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        if (this.header_list.type_vat == 0) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          let calculate = ((total_price * 7)/107);
          return sum+(calculate);
        }
        else if (this.header_list.type_vat == 1){
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          let calculate = (total_price * (7/100));
          return sum+(calculate);
        }
        else if (this.header_list.type_vat == 2){
          return sum+(0);
        }
        else if (this.header_list.type_vat == 3){
          return sum+(0);
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    total_all() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum,number) => {
        if (this.header_list.type_vat == 0){
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price);
          }
        }
        else if(this.header_list.type_vat == 1) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          let ex_vat = ((total_price * 7)/100);
          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price + ex_vat);
          }
        }
        else if(this.header_list.type_vat == 2) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price);
          }
        }
        else if(this.header_list.type_vat == 3) {
          let total_price = (( (number.price) - ((number.price * number.discount) / 100)) * number.qty_received) - number.discount_unit;
          if (total_price < 0) {
            return sum+(0)
          }
          else {
            return sum+(total_price);
          }
        }
      }, 0)
      return result;
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}
.grid_row {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_vat {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_product {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media only screen and (max-width: 1100px){
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_vat {
    display: grid;
    grid-template-columns: 45% 55%;
  }
}
@media only screen and (max-width: 700px){
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_vat {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
</style>
